import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { IGAEADLookupService } from 'app/shared/services/igaead-lookup.service';

@Component({
    selector: 'search-bar-item',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SearchBarComponent implements OnInit {
    @Output() onClear: EventEmitter<any> = new EventEmitter();
    @Output() onSearch: EventEmitter<any> = new EventEmitter();
    @Input() curretPage;
    filterText;
    documentSymbol;
    sessionID;
    constructor(private router: Router,
      private route: ActivatedRoute,
      private lookupService: IGAEADLookupService) {
    }

    ngOnInit(): void {
      this.documentSymbol = this.route.snapshot.queryParamMap.get('document');
      if(this.route.snapshot.queryParamMap.get('search')){
        let search = this.route.snapshot.queryParamMap.get('search');
        this.filterText = `${search}`;
      }
      this.sessionID = this.route.snapshot.paramMap.get('sessionID');
      if(this.documentSymbol){
        this.filterText = `"${this.documentSymbol}"`;
      }
    }

    public openPage(name: string): void {
        this.router.navigate(['ga/plenary',this.sessionID, name], {});
    }
    

    getDate(params){
        let date = new Date(params.MT_dateTimeScheduleStart).toLocaleDateString('en-us',{ weekday:"long", month:"long", day:"numeric", year:"numeric", hour:"numeric", minute:"numeric"});
        return `${date + " " + params.MT_body}`;
    }
    getTitle(segment){
        let title = segment.MTS_segmentTitle;
        for(let doc of segment.MTS_selectDocumentFromWorkPackage){
          let code = new RegExp(doc.DD_symbol1)
          title =  title.replace(code, `<a href="https://undocs.org/${doc.DD_symbol1}" target="_blank">${doc.DD_symbol1}</a>`)
        }
        return title;
    }

    getSymbols(documents){
        let links = [];
        if(documents){
          for(let document of documents){
            links.push(`<a hreg="https://undocs.org/${document.DD_symbol1}" target="_blank">${document.DD_symbol1}</a>`)
          }
          return links.join(',');
        }
        return '';
    }

    search(){
      if(this.curretPage=='Documents' && this.filterText.substring(0,2)=='A/'){
        this.filterText = `"${this.filterText}"`
      }
      this.onSearch.emit(this.filterText)
    }
    clear(){
      this.filterText = '';
      this.onClear.emit(this.filterText)
    }
}
